import { render } from "./custom_functions2.vue?vue&type=template&id=bb6ebc8c&scoped=true&ts=true"
import script from "./custom_functions2.vue?vue&type=script&lang=ts"
export * from "./custom_functions2.vue?vue&type=script&lang=ts"

import "./custom_functions2.vue?vue&type=style&index=0&id=bb6ebc8c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb6ebc8c"]])

export default __exports__